import {
	createRouter,
	createWebHistory,
	createWebHashHistory
} from 'vue-router'
import {
	useMutitabsStore
} from "@/store/mutitabs";
// 进度条
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import '../assets/css/nprogress.scss' //自定义样式
// 简单配置
NProgress.inc(0.4)
NProgress.configure({
	easing: 'ease',
	speed: 500,
	showSpinner: true
})
import {
	setStorage,
	getStorage
} from '@/utils/util'
import ProductsLayout from '@/views/products/index.vue'
import ProductsHome from '@/views/products/Home.vue'
import System from '@/views/products/pages/System.vue'
import Operation from '@/views/products/pages/Operation.vue'
import Hardware from '@/views/products/pages/Hardware.vue'
import Innovation from '@/views/products/pages/Innovation.vue'
import Data from '@/views/products/pages/Data.vue'
import Application from '@/views/products/pages/Application.vue'
import Enterprise from '@/views/products/pages/Enterprise.vue'
// 添加解决方案相关组件的导入
import SolutionsLayout from '@/views/solutions/index.vue'

const routes = [{
		path: '/',
		name: 'root',
		hidden: true,
		redirect:"/home"
	},
	{
		path:"/",
		name:"court",
		hidden:true,
		component: () => import("@/views/court/index"),
		children:[
			{
				path:"/home",
				name:"home",
				component: () => import("@/views/court/home/index"),
				hidden: true,
				meta: {
					requireAuth: false,
					title:"",
					index: '/home'
				}
			},
			{
				path:"/overview",
				name:"overview",
				component: () => import("@/views/court/overview/index"),
				hidden: true,
				meta: {
					requireAuth: false,
					title:"法院概况",
					index: '/overview'
				}
			},
			{
				path:"/article-detail",
				name:"article-detail",
				component: () => import("@/views/court/article-detail/index"),
				hidden: true,
				meta: {
					requireAuth: false,
					title:"文章详情",
					index: '/article-detail'
				}
			},
			{
				path:"/user-space",
				name:"user-space",
				component: () => import("@/views/court/user/index"),
				hidden: true,
				meta: {
					requireAuth: false,
					index: '/user-space'
				}
			},
		
	
		]
	},
	
	{ //要使用本登录页，修改上一项的component的import指向以及本配置的path: '/login'、name: 'login'、index: '/login'
		path: '/lylogin',
		name: 'lylogin',
		component: () => import('../views/lylogin.vue'),
		hidden: true,
		meta: {
			requireAuth: false,
			index: '/lylogin',
		}
	},
	{
		path: '/login',
		name: 'login',
		component: () => import('../views/login/mlogin.vue'),
		hidden: true,
		meta: {
			requireAuth: false,
			index: '/login',
		}
	},
	{
		path: '/404',
		name: '404',
		component: () => import('../views/error/404.vue'),
		hidden: true,
		meta: {
			requireAuth: false,
			index: '/404',
		}
	},
	{
		path: '/lyterminal',
		name: 'lyterminal',
		component: () => import('../views/lyterminal.vue'),
		hidden: true,
		meta: {
			requireAuth: true,
			index: '/lyterminal',
		}
	},
	{
		path: '/lyFilePreview',
		name: 'lyFilePreview',
		component: () => import('../views/other/lyFilePreview.vue'),
		hidden: true,
		meta: {
			requireAuth: true,
			index: '/lyFilePreview',
		}
	},
	{
		path: '/index',
		name: 'index',
		component: () => import('../views/index.vue'),
		iconCls: 'el-icon-tickets',
		meta: {
			requireAuth: false,
			index: '/index',
		},
		children: [
			// 超管
			{
				path: '/adminManage',
				name: 'adminManage',
				component: () => import('../views/adminManage/adminManage.vue'),
				meta: {
					requireAuth: true,
					index: '/adminManage',
				}
			},
			{
				path: '/userManage',
				name: 'userManage',
				component: () => import('../views/userManage/userManage.vue'),
				meta: {
					requireAuth: true,
					index: '/userManage',
				}
			},
			{
				path: '/userManageCrud',
				name: 'userManageCrud',
				component: () => import('../views/userManage/userManageCrud.vue'),
				meta: {
					requireAuth: true,
					index: '/userManageCrud',
				}
			},
			{
				path: '/carouselSettingsimg',
				name: 'carouselSettingsimg',
				component: () => import('../views/platformSettings/carouselSettingsimg.vue'),
				meta: {
					requireAuth: true,
					index: '/carouselSettingsimg',
				}
			},
			{
				path: '/platformSettingsother',
				name: 'platformSettingsother',
				component: () => import('../views/platformSettings/platformSettingsother.vue'),
				meta: {
					requireAuth: true,
					index: '/platformSettingsother',
				}
			},

			{
				path: '/userFeekback',
				name: 'userFeekback',
				component: () => import('../views/userFeekback/userFeekback.vue'),
				meta: {
					requireAuth: true,
					index: '/userFeekback',
				}
			},
			// 系统管理
			{
				path: '/departmentManage',
				name: 'departmentManage',
				component: () => import('../views/systemManage/departmentManage/departmentManage.vue'),
				meta: {
					requireAuth: true,
					index: '/departmentManage',
				}
			},
			{
				path: '/menuManage',
				name: 'menuManage',
				component: () => import('../views/systemManage/menuManage/menuManage.vue'),
				meta: {
					requireAuth: true,
					index: '/menuManage',
				}
			},

			{
				path: '/roleManage',
				name: 'roleManage',
				component: () => import('../views/systemManage/roleManage/roleManage.vue'),
				meta: {
					requireAuth: true,
					index: '/roleManage',
				}
			},


			{
				path: '/authorityManage',
				name: 'authorityManage',
				component: () => import('../views/systemManage/authorityManage/authorityManage.vue'),
				meta: {
					requireAuth: true,
					index: '/authorityManage',
				}
			},
			{
				path: '/buttonConfig',
				name: 'buttonConfig',
				component: () => import('../views/systemManage/buttonConfig/buttonConfig.vue'),
				meta: {
					requireAuth: true,
					index: '/buttonConfig',
				}
			},
			{
				path: '/buttonManage',
				name: 'buttonManage',
				component: () => import('../views/systemManage/button/buttonManage.vue'),
				meta: {
					requireAuth: true,
					index: '/buttonManage',
				}
			},
			{
				path: '/messagTemplate',
				name: 'messagTemplate',
				component: () => import('../views/messageCenter/messagTemplate.vue'),
				meta: {
					requireAuth: true,
					index: '/messagTemplate',
				}
			},
			{
				path: '/messagNotice',
				name: 'messagNotice',
				component: () => import('../views/messageCenter/messagNotice.vue'),
				meta: {
					requireAuth: true,
					index: '/messagNotice',
				}
			},
			{
				path: '/personalCenter',
				name: 'personalCenter',
				component: () => import('../views/personalCenter/personalCenter.vue'),
				meta: {
					requireAuth: true,
					index: '/personalCenter',
				}
			},
			{
				path: '/journalManage',
				name: 'journalManage',
				component: () => import('../views/journalManage/journalManage.vue'),
				meta: {
					requireAuth: true,
					index: '/journalManage',
				}
			},

		]
	},
	{
		path: '/products',
		name: 'Products',
		component: ProductsLayout,
		children: [
			{
				path: '',
				name: 'ProductsHome',
				component: ProductsHome
			},
			{
				path: 'system',
				name: 'System',
				component: System
			},
			{
				path: 'operation',
				name: 'Operation',
				component: Operation
			},
			{
				path: 'hardware',
				name: 'Hardware',
				component: Hardware
			},
			{
				path: 'innovation',
				name: 'Innovation',
				component: Innovation
			},
			{
				path: 'data',
				name: 'Data',
				component: Data
			},
			{
				path: 'custom',
				name: 'Application',
				component: Application
			},
			{
				path: 'enterprise',
				name: 'Enterprise',
				component: Enterprise
			}
		]
	},
	// 修改解决方案路由配置
	{
		path: '/solutions',
		name: 'Solutions',
		component: SolutionsLayout,
		children: [
			{
				path: 'operation',
				name: 'OperationSolution',
				component: () => import('@/views/solutions/components/Operation.vue'),
				meta: {
					title: '运行维护服务方案'
				}
			},
			{
				path: 'hardware',
				name: 'HardwareSolution',
				component: () => import('@/views/solutions/components/Hardware.vue'),
				meta: {
					title: '硬件维保服务方案'
				}
			},
			{
				path: 'data',
				name: 'DataSolution',
				component: () => import('@/views/solutions/components/Data.vue'),
				meta: {
					title: '数据治理服务方案'
				}
			},
			{
				path: 'enterprise',
				name: 'EnterpriseSolution',
				component: () => import('@/views/solutions/components/Enterprise.vue'),
				meta: {
					title: '企业服务解决方案'
				}
			}
		]
	},
	// 修改关于美音的路由配置
	{
		path: '/about',
		name: 'About',
		component: () => import('@/views/about/index.vue'),
		meta: {
			title: '关于美音'
		}
	},
	{
		path: '/news',
		name: 'News',
		component: () => import('@/views/news/index.vue'),
		meta: {
			title: '新闻动态',
			requireAuth: false
		}
	},
	{
		path: '/news/:id',
		name: 'NewsDetail',
		component: () => import('@/views/news/Detail.vue'),
		meta: {
			title: '新闻详情',
			requireAuth: false
		}
	},
	{
		path: '/sitemap',
		name: 'sitemap',
		component: () => import('@/views/sitemap/index.vue')
	}
]

// 路由自动化注册（默认注册到index的children里面）(静态路由优先级高于动态自动路由)
const requireComponent = require.context('../views', true, /\.vue$/) // 找到 modules 路径下的所有文件
const names = requireComponent.keys()
const autoRouters = getAutoRouterList(names)

function getAutoRouterList(names) {
	const routerList = [];
	names.forEach((name, index) => {
		if (name.indexOf("/components/") == -1 && name != './index.vue' && name != './login.vue' && name !=
			'./lyterminal.vue') {
			let isSame = false
			const componentConfig = requireComponent(name)
			const componentName = name.split('/').pop()?.split('.')[0] //根据路径截取name文件名（去除后缀和前面目录）
			for (var i = 0; i < routes.length; i++) {
				if (routes[i].path == "/" || routes[i].path == "/login" || routes[i].path == "/lyterminal") {
					continue
				}
				if (routes[i].name === componentName) {
					isSame = true
					break
				}
				if (routes[i].path === '/index' && routes[i].children.length > 0) {
					for (var s = 0; s < routes[i].children.length; s++) {
						if (routes[i].children[s].name === componentName) {
							isSame = true
							break
						}
					}
				}
			}
			if (!isSame) {
				const path = "/" + componentName
				routerList.push({
					path: path,
					name: componentName,
					component: componentConfig.default,
					meta: {
						requireAuth: true,
						index: path,
					}
				});
			}
		}

	});
	for (var t = 0; t < routes.length; t++) {
		if (routes[t].path == '/index') {
			routerList.forEach(drouter => {
				routes[t].children.push(drouter)
			})
			break
		}
	}
	return routerList;
}

const router = createRouter({
	//history模式
	history: createWebHistory(process.env.BASE_URL),
	//hash模式
	// history: createWebHashHistory(),
	routes: routes,
	// 禁用Vue Router的默认滚动行为，让我们自己控制
	scrollBehavior(to, from, savedPosition) {
		// 返回false禁用默认滚动行为，让路由守卫处理滚动重置
		return false
	}
})

//判断访问路径路由name是否存在
function isRouterNameExist(name) {
	let isExist = false
	if (name) {
		if (routes.some(item => name == item.name)) {
			return true
		}
		for (var t = 0; t < routes.length; t++) {
			if (routes[t].children && routes[t].children.length > 0) {
				if (routes[t].children.some(item => name == item.name)) {
					isExist = true
					break
				}
			}
		}
	} else {
		return false
	}
	return isExist
}
//判断访问路径路由path是否存在
function isRouterPathExist(path) {
	let isExist = false
	if (path) {
		if (routes.some(item => path == item.path)) {
			return true
		}
		for (var t = 0; t < routes.length; t++) {
			if (routes[t].children && routes[t].children.length > 0) {
				if (routes[t].children.some(item => path == item.path)) {
					isExist = true
					break
				}
			}
		}
	} else {
		return false
	}
	return isExist
}

// 定义不需要登录验证的白名单路由
const whiteList = ['/login', '/home', '/solutions', '/products']  // 添加 /home 到白名单

// 路由守卫
router.beforeEach(async (to, from, next) => {
	// 页面切换时重置滚动，但排除锚点跳转
	const toPathWithoutHash = to.path.split('#')[0]
	const fromPathWithoutHash = from.path ? from.path.split('#')[0] : ''

	// 只有在不同页面间跳转且没有锚点时才重置滚动
	if (toPathWithoutHash !== fromPathWithoutHash && !to.hash) {
		document.documentElement.scrollTop = 0
		document.body.scrollTop = 0
		window.scrollTo(0, 0)
		window.scrollTo({ top: 0, behavior: 'instant' })
	}

	const mutitabsStore = useMutitabsStore()

	// 添加到缓存
	if (to.name) {
		mutitabsStore.addCachedView(to)
	}
	
	// 如果是白名单路由，直接放行
	if (whiteList.includes(to.path)) {
		next()
		return
	}

	// 进度条
	NProgress.start()
	let userId = mutitabsStore.userId ? mutitabsStore.userId : ''
	if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
		if (userId) { // 通过vuex state获取当前的token是否存在
			let menuList = JSON.parse(getStorage('menuList'))
			if (menuList && (menuList.filter(item => item.url == to.name).length > 0 || (whiteList.indexOf(to.name) !== -
					1))) {
				if (to.path) {
					next()
				} else if (isRouterPathExist(to.path)) {
					next()
				} else {
					next({
						path: '/404'
					})
				}
			} else {
				next({
					path: '/404'
				})
			}
		} else {
			mutitabsStore.logout('false')
			next({
				path: '/login'
			})
		}
	} else {
		if (to.path == "/login" || to.path == "/") {
			if (userId) {
				let tabsValue = getStorage("TabsValue")
				if (tabsValue) {
					if (isRouterNameExist(tabsValue)) {
						if (tabsValue === 'login') {
							next({
								path: '/404'
							})
						} else {
							mutitabsStore.switchtab(tabsValue)
						}
					} else {
						next({
							path: '/404'
						})
					}
				} else {
					let tabsPage = JSON.parse(getStorage("tabsPage"))
					if (tabsPage) {
						if (isRouterNameExist(tabsPage[0].name)) {
							mutitabsStore.switchtab(tabsPage[0].name)
						} else {
							next({
								path: '/404'
							})
						}

					} else {
						next({
							path: '/404'
						})
					}
				}
			} else {
				if (to.name) {
					next()
				} else if (isRouterPathExist(to.path)) {
					next()
				} else {
					next({
						path: '/404'
					})
				}
			}
		} else {
			if (to.name) {
				next()
			} else if (isRouterPathExist(to.path)) {
				next()
			} else {
				next({
					path: '/404'
				})
			}
		}
	}
})
//在路由跳转后用NProgress.done()标记下结束
router.afterEach((to, from) => {
	NProgress.done()

	// 路由完成后确保滚动重置，但排除锚点跳转
	const toPathWithoutHash = to.path.split('#')[0]
	const fromPathWithoutHash = from.path ? from.path.split('#')[0] : ''

	// 只有在不同页面间跳转且没有锚点时才重置滚动
	if (toPathWithoutHash !== fromPathWithoutHash && !to.hash) {
		setTimeout(() => {
			document.documentElement.scrollTop = 0
			document.body.scrollTop = 0
			window.scrollTo(0, 0)
			window.scrollTo({ top: 0, behavior: 'instant' })
		}, 50)
	}
})
export default router